export enum AccountUpdateTab {
  Personal = 'account_tab_personal',
  Contact = 'account_tab_contact',
  Finance = 'account_tab_finance'
}
